import { useEffect } from "react";

// Lightweight SEO helper – sets document.title and meta description per route.
export const SEO = ({ title, description }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let el = document.querySelector('meta[name="description"]');
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute("name", "description");
                document.head.appendChild(el);
            }
            el.setAttribute("content", description);
        }
    }, [title, description]);
    return null;
};
